module.exports = "/img/_/_/_/assets/images/creeper/book/epic//3.jpg?da5ccd7b27b71f6b81e59551c7f1446b";